export default __webpack_public_path__ + "static/media/shastasummit-crop.861e3b20.jpg";